import { END_SESSION } from '../actions/authActions';
import { SET_RESTORE_POINTS } from '../actions/restorePointActions';

const DEFAULT_STATE = [];

export default function restorePointsReducer(state = DEFAULT_STATE, { type, payload = [] }) {
  switch (type) {
    case END_SESSION:
      return DEFAULT_STATE;
    case SET_RESTORE_POINTS:
      return payload;
    default:
      return state;
  }
}

export const getRestorePoints = (state) => {
  return state;
};
